
export const GET_STANDERD_BUSINESS_ACTIVITY = "GET_STANDERD_BUSINESS_ACTIVITY"
export const GET_USERS_DATA = "GET_USERS_DATA"
export const EXPORT_PARAMETER_STORE = "EXPORT_PARAMETER_STORE"
export const TABLE_DATA_STORE = "TABLE_DATA_STORE"
export const EMPTY_STORE = "EMPTY_STORE"

